import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    subcategoryDetails:{
        subcategory_name: "",
        category_id:0,
        sub_category_image: []
    },
    modal: false,
    subcategoryEdit: false,
    subcategory: [],
    loading:false,
    edit:false,
    searchSubCategory:""
}

const subcategoryReducer = createSlice({
    name: "subcategoryReducer",
    initialState: initialState,
    reducers: {
        updateSubCategoryDetails:( state, {type, payload}) =>{
            state.subcategoryDetails = payload
        },
        updateModal: (state, {  type, payload }) => {
            state.modal = payload
        },
        updateSubCategoryEdit: (state, { type, payload }) => {
            state.subcategoryEdit = payload
        },
        updateLoadingSubCategories: (state, { type, payload }) => {
            state.loading = payload
        },
        updateSubCategories: (state, { type, payload }) => {
            state.subcategory = payload
        },
        updateEdit: (state, { payload }) => {
            state.edit = payload
        },
        updateSearchSubCategory: (state, { type, payload }) => {
            state.searchSubCategory = payload
        },
    }
})

export const { updateSubCategoryDetails,updateModal, updateSubCategoryEdit,updateLoadingSubCategories, updateSubCategories, updateEdit, updateSearchSubCategory } = subcategoryReducer.actions

export default subcategoryReducer.reducer;